import { render } from "./OrderFilters.vue?vue&type=template&id=3f6d2e38"
import script from "./OrderFilters.vue?vue&type=script&lang=js"
export * from "./OrderFilters.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__